import { DoBoxRule } from '@this+that/models';
import { create } from 'zustand';

interface DoBoxRulesState {
  rules: DoBoxRule[];
  isLoading: boolean;
  hasLoaded: boolean;
}

interface DoBoxRulesActions {
  setRules(rules: DoBoxRule[]): void;
  upsertRule(rule: DoBoxRule): void;
  removeRule(id: string): void;
  setLoading(loading: boolean): void;
  setHasLoaded(loaded: boolean): void;
  resetState(): void;
}

type DoBoxRulesStore = DoBoxRulesState & DoBoxRulesActions;

export const useDoBoxRulesStore = create<DoBoxRulesStore>((set, get) => ({
  rules: [],
  isLoading: false,
  hasLoaded: false,
  setRules: (rules) => set({ rules }),
  upsertRule: (rule) => {
    const existing = get().rules.findIndex((r) => r.id === rule.id);
    if (existing !== -1) {
      set((state) => ({
        rules: state.rules.map((r) => (r.id === rule.id ? rule : r)),
      }));
    } else {
      set((state) => ({ rules: [...state.rules, rule] }));
    }
  },
  removeRule: (id) =>
    set((state) => ({ rules: state.rules.filter((r) => r.id !== id) })),
  setLoading: (loading) => set({ isLoading: loading }),
  setHasLoaded: (loaded) => set({ hasLoaded: loaded }),
  resetState: () => set({ rules: [], isLoading: false, hasLoaded: false }),
}));
